import React from "react"
import {Col, Form} from "react-bootstrap"
import {countries} from "../variables"
import {deliveryNames, personalDataNames} from "../helpers/enums"
import {withRouter} from "react-router-dom"

const PersonalDataForm = ({selectedFormOfDelivery, handlePersonalDataChange}) => {

    return (
        <div controlid="personalDataForm">
            <Form.Row>
                <Form.Group as={Col} md={{span: 6, offset: 6}}
                            style={{border: "#eee solid 1px", backgroundColor: "#eee", borderRadius: "4px"}}>
                    <Form.Label className="font-weight-bold">Dane do wysyłki</Form.Label>
                    <Form.Row>

                        <Form.Group as={Col} md={5} controlId="formGridName">
                            <Form.Label>Imię*</Form.Label>
                            <Form.Control placeholder="name" name={personalDataNames.NAME} required
                                          onChange={handlePersonalDataChange}/>
                        </Form.Group>

                        <Form.Group as={Col} md={7} controlId="formGridSurname">
                            <Form.Label>Nazwisko*</Form.Label>
                            <Form.Control placeholder="surname" name={personalDataNames.SURNAME} required
                                          onChange={handlePersonalDataChange}/>
                        </Form.Group>

                    </Form.Row>

                    <Form.Row>

                        <Form.Group as={Col} md={10} controlId="formGridEmail">
                            <Form.Label>Email*</Form.Label>
                            <Form.Control type="email" placeholder="name@example.com" name={personalDataNames.EMAIL}
                                          required onChange={handlePersonalDataChange}/>
                        </Form.Group>

                        <Form.Group as={Col} xs={7} controlId="formGridNumber">
                            <Form.Label>Numer telefonu*</Form.Label>
                            <Form.Control placeholder="phone number" name={personalDataNames.PHONE_NUMBER} required
                                          onChange={handlePersonalDataChange}/>
                        </Form.Group>

                    </Form.Row>

                    <Form.Row>

                        <Form.Group as={Col} md={8} controlId="formGridAddress">
                            <Form.Label>Ulica*</Form.Label>
                            <Form.Control placeholder="street" name={personalDataNames.STREET} required
                                          onChange={handlePersonalDataChange}/>
                        </Form.Group>

                        <Form.Group as={Col} xs={6} md={4} controlId="formGridHomeNumber">
                            <Form.Label>Numer domu*</Form.Label>
                            <Form.Control placeholder="number" name={personalDataNames.HOUSE_NUMBER} required
                                          onChange={handlePersonalDataChange}/>
                        </Form.Group>

                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} xs={6} md={5} controlId="formGridZip">
                            <Form.Label>Kod pocztowy*</Form.Label>
                            <Form.Control placeholder="zip" name={personalDataNames.ZIP} required
                                          onChange={handlePersonalDataChange}/>
                        </Form.Group>

                        <Form.Group as={Col} xs={11} md={7} controlId="formGridCity">
                            <Form.Label>Miasto*</Form.Label>
                            <Form.Control placeholder="city" name={personalDataNames.CITY} required
                                          onChange={handlePersonalDataChange}/>
                        </Form.Group>

                    </Form.Row>

                    <Form.Row>

                        <Form.Group as={Col} xs={11} md={6} controlId="formGridCountry">
                            <Form.Label>Państwo*</Form.Label>
                            <Form.Control as="select" defaultValue="Poland" name={personalDataNames.COUNTRY} required
                                          onChange={handlePersonalDataChange}>
                                <option>Wybierz...</option>
                                {countries.map(country =>
                                    <option key={country} value={country}>{country}</option>
                                )}
                            </Form.Control>
                        </Form.Group>

                        {selectedFormOfDelivery === deliveryNames.PARCEL_LOCKER
                        &&
                        <Form.Group as={Col} xs={6} controlId="formGridNameOfParcelLocker">
                            <Form.Label>Nazwa paczkomatu*</Form.Label>
                            <Form.Control placeholder="WRO14L" name={personalDataNames.PARCEL_LOCKER_NUMBER} required
                                          onChange={handlePersonalDataChange}/>
                        </Form.Group>
                        }

                    </Form.Row>

                </Form.Group>

            </Form.Row>

        </div>
    )
}

export default withRouter(PersonalDataForm)